import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Update execution events of an Order.
 *
 * @private
 */
export const updateExecutionEvents = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.ui.forms.ExecutionEventsChanges,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/updateExecutionEvents', async (executionEventsChanges, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/order/updateExecutionEvents', {
      category: 'rpc',
      type: 'rpc/order/updateExecutionEvents',
      executionEventsChanges,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateExecutionEvents}`,
      { tags: ['rpc', 'order'], info: executionEventsChanges },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update execution events for order ${executionEventsChanges.id} failed`,
      error,
    })
  }
})
